import { Box } from '@mui/material'
import { Permission } from '@storage/app/models'
import { AddEntityButton } from '@storage/components/AddEntityButton'
import { useStores } from '@storage/hooks/use-stores.hook'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { BerthsList } from '../components/berths-list'
import { BerthsFeatureStore } from '../stores'

interface Props {
  featureStore: BerthsFeatureStore
}

export const BerthsListContainer = observer(
  ({ featureStore: { berthsList, berthsDialog, deleteDialog } }: Props) => {
    const { berthStore, authStore } = useStores()
    const { t } = useTranslate()

    const handleEditItem = (id: string) => {
      berthsDialog.toggle(id)
    }

    const handleDeleteItem = async () => {
      if (!deleteDialog.id) return

      await berthStore.delete(deleteDialog.id)
      deleteDialog.close()
    }

    return (
      <Box>
        <BerthsList
          canWrite={authStore.hasPermission(Permission.WriteBerths)}
          items={berthsList.filteredBerths}
          onEditItem={handleEditItem}
          onDeleteItem={id => deleteDialog.open(id)}
        />

        {authStore.hasPermission(Permission.WriteBerths) && (
          <AddEntityButton onAddEntity={() => berthsDialog.toggle()} />
        )}

        <ConfirmationDialog
          open={deleteDialog.isOpen}
          title={t('deleteBerthQuestion', 'Delete berth?')}
          message={t('confirmBerthDelete', 'All related visits would be unassigned.')}
          primaryActionText={t('yesDelete', 'Yes, delete')}
          closeLabel={t('cancelBerthDeleting', 'No, keep berth')}
          onClose={deleteDialog.close}
          onConfirm={handleDeleteItem}
        />
      </Box>
    )
  },
)
